/**
 * Phone number and WhatsApp utility functions
 */

/**
 * Format phone number to (___) ___-____ format for display
 * @param phone - Phone number string (can be undefined/null)
 * @returns Formatted phone number string or '-' if empty
 */
export const formatPhoneNumber = (phone: string | undefined | null): string => {
  if (!phone) return '-';
  
  // Remove all non-digit characters
  const cleaned = phone.replace(/\D/g, '');
  
  // Format as (___) ___-____
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  } else if (cleaned.length === 11 && cleaned[0] === '1') {
    // Handle US numbers with country code
    return `(${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7)}`;
  }
  
  // Return original if doesn't match expected format
  return phone;
};

/**
 * Format phone input as user types (for input fields)
 * @param value - Raw phone input value
 * @returns Formatted phone number string
 */
export const formatPhoneInput = (value: string): string => {
  const cleaned = value.replace(/\D/g, '');
  
  if (cleaned.length <= 3) {
    return cleaned;
  } else if (cleaned.length <= 6) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
  } else {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
  }
};

/**
 * Generate WhatsApp link from phone number
 * @param phone - Phone number string (can be undefined/null)
 * @returns WhatsApp URL string or null if phone is invalid/empty
 */
export const getWhatsAppLink = (phone: string | undefined | null): string | null => {
  if (!phone) return null;
  
  // Remove all non-digit characters
  const cleaned = phone.replace(/\D/g, '');
  
  // Handle different formats
  let phoneNumber = cleaned;
  if (cleaned.length === 10) {
    // US number without country code - add country code
    phoneNumber = `1${cleaned}`;
  } else if (cleaned.length === 11 && cleaned[0] === '1') {
    // Already has US country code
    phoneNumber = cleaned;
  } else if (cleaned.length > 0) {
    // International number or other format
    phoneNumber = cleaned;
  } else {
    return null;
  }
  
  return `https://wa.me/${phoneNumber}`;
};
